import {
  actionCreator,
  checkHttpStatus, 
  jsonApiHeader, 
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
  PatientSkillAcqActiveTargetListActionTypes, 
  GET_PATIENT_SKILL_ACQ_ACTIVE_TARGETS_LIST_API,
  GET_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_LIST_API,
  POST_PATIENT_SKILL_ACQ_COLLECT_DATA,
  GET_PATIENT_SKILL_ACQ_COLLECTED_Data_LIST_API,
  DELETE_PATIENT_SKILL_ACQ_COLLECTED_DATA,
  GET_PATIENT_SKILL_ACQ_TASK_ANALYSIS_LIST_API,
  DELETE_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_API,
  GET_PATIENT_SKILL_ACQ_SELECTED_PROGRAMS_FOR_TARGET_API,
  GET_PATIENT_SKILL_ACQ_ACTIVE_TARGETS_LIST_NEWFLOW_API,
  DELETE_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_API_NEW_FLOW,
  GET_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_LIST_API_NEW_FLOW
} from '../constants/ApiConstants';
import Alert from 'react-s-alert';
import { reset } from 'redux-form';
import { createSearchUrlForCustomAPI } from '../../../../../../../../../actions/utilAction';


export const PatientSkillAcqActiveTargetist = (searchObj) => {
let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetList.REQUEST));
      fetch(`${GET_PATIENT_SKILL_ACQ_ACTIVE_TARGETS_LIST_API}${query_params}&includeMasteredTargetsOnly=true`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetList.SUCCESS, response));
              } else {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetList.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_patientSkillAcqActiveTargetList', error);
          });
  };
};

export const PatientSkillAcqActiveTargetListNewFlow = (searchObj) => {
let query_params = createSearchUrlForCustomAPI(searchObj);
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetListNewFlow.REQUEST));
      fetch(`${GET_PATIENT_SKILL_ACQ_ACTIVE_TARGETS_LIST_NEWFLOW_API}${query_params}&includeMasteredTargetsOnly=true`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetListNewFlow.SUCCESS, response));
              } else {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqActiveTargetListNewFlow.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_patientSkillAcqActiveTargetListNewFlow', error);
          });
  };
};

export const getPatientSkillAcqPreviousTrialistNewFlow = (patientId,sessionId, skillsAcquisitionTargetId) => {  
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqPreviousTrialList.REQUEST));
      fetch(`${GET_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_LIST_API_NEW_FLOW}?patientId=${patientId}&sessionId=${sessionId}&skillsAcquisitionTargetId=${skillsAcquisitionTargetId}`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqPreviousTrialList.SUCCESS, response));
              } else {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqPreviousTrialList.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_patientSkillAcqPreviousTrialList', error);
          });
  };
};

export const getPatientSkillAcqPreviousTrialist = (patientId,sessionId, skillsAcquisitionTargetId) => {
return (dispatch, getState) => {
    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqPreviousTrialList.REQUEST));
    fetch(`${GET_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_LIST_API}?patientId=${patientId}&sessionId=${sessionId}&skillsAcquisitionTargetId=${skillsAcquisitionTargetId}`, {
        method: 'get',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
        .then(checkHttpStatus)
        .then(function (response) {
            if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqPreviousTrialList.SUCCESS, response));
            } else {
                dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqPreviousTrialList.SUCCESS, null));
            }
        }).catch(function (error) {
            console.log('error get_patientSkillAcqPreviousTrialList', error);
        });
};
};

export const savePatientSkillsAcquisitionCollectedData = (authData, patientId,sessionId, skillsAcquisitionTargetId, targetType) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectData.REQUEST));
    fetch(`${POST_PATIENT_SKILL_ACQ_COLLECT_DATA}`, {
      method: 'POST',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      body: JSON.stringify(authData),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectData.SUCCESS, response));
          if(targetType === 'DTT'){
            dispatch(getPatientSkillAcqPreviousTrialistNewFlow(patientId,sessionId, skillsAcquisitionTargetId))
            dispatch(reset('DTTModalForm'))
          } else {
            dispatch(reset('TaskAnalysisModalForm'))
          }
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.post_patientSkillAcqCollectData.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error post_patientSkillAcqCollectData', error);
      });
  };
};

export const getPatientSkillAcqCollectedData = (patientId,sessionId, sessionDate, targetType)  => {
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectedDataList.REQUEST));
      fetch(`${GET_PATIENT_SKILL_ACQ_COLLECTED_Data_LIST_API}?patientId=${patientId}&sessionId=${sessionId}&sessionDate=${sessionDate}&targetType=${targetType}&includeMasteredTargetsOnly=true`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectedDataList.SUCCESS, response));
              } else {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqCollectedDataList.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_patientSkillAcqCollectedDataList', error);
          });
  };
};

export const deletePatientSkillAcqCollectedData = (patientId,sessionId, sessionDate,collectedDataId, skillsAcquisitionTargetId, targetType) => {
  Alert.closeAll();
  return (dispatch, getState) => {
    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqCollectedData.REQUEST));
    fetch(`${DELETE_PATIENT_SKILL_ACQ_COLLECTED_DATA}?collectedDataId=${collectedDataId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqCollectedData.SUCCESS, response));
          if(targetType === "DTT") {            
            dispatch(getPatientSkillAcqCollectedData(patientId,sessionId, sessionDate, "DTT"));
            dispatch(getPatientSkillAcqPreviousTrialistNewFlow(patientId,sessionId, skillsAcquisitionTargetId));
          } else {
            dispatch(getPatientSkillAcqCollectedData(patientId,sessionId, sessionDate, "Task Analysis"));
          }
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqCollectedData.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqCollectedData.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error delete_patientSkillAcqCollectedData', error);
      });
  };
};

export const getPatientSkillAcqTaskAnalysislist = (patientId) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqTaskAnalysisList.REQUEST));
      fetch(`${GET_PATIENT_SKILL_ACQ_TASK_ANALYSIS_LIST_API}?patientId=${patientId}`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqTaskAnalysisList.SUCCESS, response));
              } else {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqTaskAnalysisList.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_patientSkillAcqTaskAnalysisList', error);
          });
  };
};

export const deletePatientSkillAcqPreviousTrial= (collectedDataId,patientId,sessionId, skillsAcquisitionTargetId) => {
  Alert.closeAll();
  return (dispatch, getState) => {
    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.REQUEST));
    fetch(`${DELETE_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_API}?collectedDataId=${collectedDataId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.SUCCESS, response));
          dispatch(getPatientSkillAcqPreviousTrialist(patientId,sessionId, skillsAcquisitionTargetId))
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error delete_patientSkillAcqPrevTrial', error);
      });
  };
};

export const deletePatientSkillAcqPreviousTrial_NewFlow= (patientId,sessionId, sessionDate, skillsAcquisitionTargetId) => {
  Alert.closeAll();
  return (dispatch, getState) => {
    dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.REQUEST));
    fetch(`${DELETE_PATIENT_SKILL_ACQ_PREVIOUS_TRIAL_API_NEW_FLOW}?patientId=${patientId}&sessionDate=${sessionDate}&skillAquisitionTargetId=${skillsAcquisitionTargetId}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.SUCCESS, response));
          dispatch(getPatientSkillAcqPreviousTrialistNewFlow(patientId,sessionId, skillsAcquisitionTargetId))
        } else if (response.statusCode === 401 || response.statusCode === 422) {
          showWarningMessage(response.message);
          dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.SUCCESS, null));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.delete_patientSkillAcqPrevTrial.SUCCESS, null));
        }
      }).catch(function(error) {
        console.log('error delete_patientSkillAcqPrevTrial', error);
      });
  };
};


export const selectedProgramForTargetAction = (patientId, skillsAcquisitionProgramIds) => {
  return (dispatch, getState) => {
      dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqSelectedProgramForTarget.REQUEST));
      fetch(`${GET_PATIENT_SKILL_ACQ_SELECTED_PROGRAMS_FOR_TARGET_API}?patientId=${patientId}&skillsAcquisitionProgramIds=${skillsAcquisitionProgramIds}`, {
          method: 'get',
          headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
          .then(checkHttpStatus)
          .then(function (response) {
              if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqSelectedProgramForTarget.SUCCESS, response));
              } else {
                  dispatch(actionCreator(PatientSkillAcqActiveTargetListActionTypes.get_patientSkillAcqSelectedProgramForTarget.SUCCESS, null));
              }
          }).catch(function (error) {
              console.log('error get_patientSkillAcqSelectedProgramForTarget', error);
          });
  };
};




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/Maintenance/components/targets/actions/targetsAction.js